import {
  stringParam
} from './../filter'
import {
  clientId,
  brandId
} from './../config'
// const { accessToken } = JSON.parse(window.localStorage.getItem('user'))
let Vue = require('vue');
let qs = require('qs');
import Axios from 'axios'
export default function (url, data, method, customerQuery, isFormData) {
  // Vue.http.options.emulateJSON = true;

  const _this = this;
  const user = JSON.parse(window.localStorage.getItem('user'))
  let query = {
    clientId: clientId,
    brandId: brandId,
    accessToken: user ? user.accessToken : ''
  }
  let Authorization = window.localStorage.user ? JSON.parse(window.localStorage.user).userId : data.userId;
  if (!data) {
    data = {};
  }
  if ('post' == method) {
    data.clientId = clientId;
    data.brandId = brandId;
  }
  // if (data.userId && data.clientId) {
  //   query = {}
  // }

  // if(!customerQuery) {
  // 	Axios.defaults.headers.common['Authorization'] = 'Basic '+window.btoa( Authorization +':');
  // 	Axios.defaults.withCredentials = true;
  // }

  Axios.defaults.withCredentials = true;

  // Axios.defaults.headers.common['Authorization'] = 'Basic '+window.btoa( Authorization +':');
  // Axios.defaults.withCredentials = true;
  return Axios[method](url + '?' + stringParam(query), method == 'get' ? {
    params: data
  } : isFormData ? qs.stringify(data) : data).then(
    res => {
      let data = res.data;
      if (data.errcode == 10008 || data.errcode == 10009 || data.errcode == 17 || data.errcode == 18 || data.errcode == 27) {
        Vue.prototype.$toast('账号异常')
        window.localStorage.removeItem("user")
        window.location.assign('/')
        return false
      } else if (data.errcode == 15 || data.errcode == 26 || data.errcode == 401) {
        Vue.prototype.$toast(data.msg,'error')
        return false;
      }
      return data;
    }).catch(
    err => err
  )
}



// WEBPACK FOOTER //
// ./src/fetch/http.js